export default "__VITE_ASSET__5d485c6f__"